import axios from "axios";
import { BASE_URL, } from "common/constants";

// Set config defaults when creating the instance
export const requester = axios.create({ baseURL: BASE_URL, });

requester.interceptors.request.use(config => {
  const localLang = localStorage.getItem("lang");
  config.headers[ "Content-Type" ] = "application/json";
  config.headers[ "Accept-Language" ] = localLang ? localLang : "ky";
  return config;
});
